import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonDeathAutorityCrumbs } from 'civil-status/constants/place';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformResponse } from 'civil-status/utils/place';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import FormPlace from 'civil-status/components/place/form';

const DeathAutorityDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [deathAutorityData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/${DomainType.DeathAutority}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = deathAutorityData.data as PlaceForm;

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonDeathAutorityCrumbs, { name: 'Visualizza autorità decesso' }]}
      />
      {deathAutorityData.isLoading ||
      deathAutorityData.pristine ||
      deathAutorityData.error ? undefined : (
        <FormPlace title="Visualizza autorità decesso" disabled initialValues={values} isAutority />
      )}
    </Fragment>
  );
};

DeathAutorityDetailPage.displayName = 'Death Autority detail page component';

export default DeathAutorityDetailPage;
